module.exports = __webpack_public_path__ + "static/media/zirka.9e07c70a.png";